import React from 'react'
import { Step } from '@mui/material'
import { GridStepper } from '@front/squirtle'

import TypeSection from './Section/Type'
import AudienceSection from './Section/Audience'
import JobSection from './Section/Job'
import JobInfoSection from './Section/JobInfo'

const NotifyDrivers = (props) =>
  <GridStepper groupsCount={[4]} activeStep={0} orientation="vertical">
    <Step><TypeSection /></Step>
    <Step><JobSection /></Step>
    <Step><AudienceSection /></Step>
    <Step><JobInfoSection /></Step>
  </GridStepper>

export default NotifyDrivers
